
import { defineComponent, reactive, watch } from 'vue'
import TimeSeeker from '@/components/common/EarthquakeTimeSeeker.vue'
import $ from 'jquery'

type State = {
  targetID: string
}

export default defineComponent({
  components: {
    TimeSeeker,
  },

  props: {
    historyTargets: {
      type: Object,
      default: null,
    },
    showAdminBack: {
      type: Boolean,
      default: false,
      required: false,
    },

    isShowSummary: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  setup(props, { emit }) {
    const state = reactive<State>({
      targetID: '',
    })
    const movePrev = () => {
      state.targetID = props.historyTargets.prev
    }
    const moveNow = () => {
      state.targetID = props.historyTargets.now
      emit('click-target', state.targetID)
    }
    const moveNext = () => {
      state.targetID = props.historyTargets.next
    }

    const showSummary = () => {
      emit('show-summary')
    }

    const hideSummary = () => {
      emit('hide-summary')
    }

    const openInfo = () => {
      let modal = $('#modal-area')
      if (modal.css('display') == 'none') modal.css('display', 'block')
      else modal.css('display', 'none')
    }

    watch(
      () => state.targetID,
      value => emit('click-target', value)
    )

    return {
      movePrev,
      moveNow,
      moveNext,
      showSummary,
      hideSummary,
      openInfo,
    }
  },
})
